import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-thank-page-blog-suscription',
  templateUrl: './thank-page-blog-suscription.component.html',
  styleUrls: ['./thank-page-blog-suscription.component.scss']
})
export class ThankPageBlogSuscriptionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
